import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { Button, IconButton, Stack, useMediaQuery } from "@mui/material";
import { FormTextField } from "UI/FormTextField";
import { DialogWindow } from "../DialogWindow";
import { ButtonInfo } from "./ReferralForm.common";
import { useTheme } from "@emotion/react";

export const QuestionForm = ({
  handleResetAndBack,
  recipientName,
  provider,
  sender,
  control,
  watch,
  isButtonEnabled,
  loading,
  onQuestionSubmit,
  handleClose = null,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <DialogWindow
      handleClose={handleClose}
      withCloseButton={!!handleClose}
      title={
        <Stack direction={"row"} alignItems={"center"} gap={1}>
          <IconButton aria-label="close" onClick={handleResetAndBack}>
            <ArrowBackIosNewIcon />
          </IconButton>
          Ask a Question
        </Stack>
      }
      content={
        <Stack gap={2} minWidth={isMobile ? "calc(100vw - 160px)" : 400}>
          <ButtonInfo
            recipientName={recipientName}
            provider={provider}
            sender={sender}
          />
          <Stack direction={"column"} alignItems={"flex-start"}>
            <FormTextField
              id="question"
              name="question"
              placeholder="Type your question here"
              control={control}
              rules={{ required: "is required" }}
              InputProps={{
                autoComplete: "off",
              }}
              sx={{
                "& textarea": {
                  minHeight: 150,
                },
              }}
              multiline
            />
          </Stack>
        </Stack>
      }
      actions={
        <Stack
          flex={1}
          direction={"row"}
          gap={1}
          justifyContent={"center"}
          alignItems={"center"}
        >
          <Button
            variant="contained"
            color="primary"
            disabled={!isButtonEnabled || loading}
            onClick={onQuestionSubmit}
          >
            Send
          </Button>
        </Stack>
      }
    />
  );
};
